import React from "react";

export default function CardVideo(props) {
  if (!props.src) {
    return null;
  }

  return (
    <div style={{ width: "400px" }}>
      <video
        // preload
        controls="controls"
        autoPlay={false}
        width="400px"
        src={ props.src.replaceAll(" ", "%20")}
      />
    </div>
  );
}
